import client from './index'

const getData = (data) => client['api'].get(`dekan-signature`, {params: data})
const store = (data) => client['api'].post(`dekan-signature`, data, {"Content-Type": "multipart/form-data",  onUploadProgress: progressEvent => {
    let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    store.dispatch('setLoading',percentCompleted)
  }})
const update = (data,id) => client['api'].patch(`dekan-signature/update/${id}`, data,{"Content-Type": "multipart/form-data",  onUploadProgress: progressEvent => {
    let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    store.dispatch('setLoading',percentCompleted)
  }})
const setToActive = (id) => client['api'].patch(`dekan-signature/status/${id}`)

export {
    getData,
    store,
    update,
    setToActive
}